<!-- PAGE TITLE
        ================================================== -->
<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>Packages </h1>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>

<!-- CONTACT FORM
        ================================================== -->
<section class="bg-light-yellow">
    <div class="container">
        <div class="contact-us rounded">
            <div class="row mt-n2-9">
                <div class="col-lg-7 mt-2-9">
                    <div class="section-title-02 mb-3 position-relative">
                        <h2 class="title-main2 mb-0">Enquiry Form</h2>
                        <!-- <div class="line"></div> -->
                    </div>


                    <!-- <form id="enquiryForm" onsubmit="validateModalForm(event)" class="contact quform"> -->
                    <form id="enquiryForm" class="contact quform" novalidate>

                        <div class="row">

                            <!-- Name -->
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Your Name *</label>
                                    <input type="text" class="form-control" name="name" [(ngModel)]="formData.Name"
                                        placeholder="Your Name *">
                                </div>
                            </div>

                            <!-- Email -->
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Email *</label>
                                    <input type="email" class="form-control" name="email" [(ngModel)]="formData.Email"
                                        placeholder="Email *">
                                </div>
                            </div>

                            <!-- Phone -->
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Phone *</label>
                                    <input type="tel" class="form-control" maxlength="10" name="phone"
                                        [(ngModel)]="formData.Phone" placeholder="Phone *">
                                </div>
                            </div>

                            <!-- Plan -->
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Select Plan *</label>
                                    <select class="form-control" name="plan" [(ngModel)]="formData.Plan">
                                        <option [ngValue]="'null'" disabled>Select Plan</option>
                                        <option [ngValue]="'Silver Plan'">Silver Plan</option>
                                        <option [ngValue]="'Gold Plan'">Gold Plan</option>
                                        <option [ngValue]="'Platinum Plan'">Platinum Plan</option>
                                    </select>
                                </div>
                            </div>

                            <!-- Location -->
                            <!-- <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Location *</label>
                                    <input type="text" class="form-control" name="location"
                                        [(ngModel)]="formData.Location" placeholder="Location *">
                                </div>
                            </div> -->
                            <!-- City dropdown - replace your existing Location input block with this -->
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>City *</label>
                                    <select class="form-control" id="city" [(ngModel)]="formData.CityID" name="city">
                                        <option [ngValue]="null" disabled>Select City*</option>
                                        <option *ngFor="let city of cities" [ngValue]="city.CityID">{{ city.CityName }}
                                        </option>
                                    </select>
                                    <span id="error-location" class="error-message"></span>
                                </div>
                            </div>

                            <!-- Message -->
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <label>Message</label>
                                    <textarea class="form-control" name="message" rows="2"
                                        [(ngModel)]="formData.Message"
                                        placeholder="Any specific requirements?"></textarea>
                                </div>
                            </div>


                            <div class="col-md-12">
                                <!-- Consent with shared line -->
                                <div class="consent-wrapper">
                                    <label class="consent-label">
                                        <input type="checkbox" class="consent-checkbox" [(ngModel)]="formData.consent"
                                            id="consent" name="consent" required>
                                        <span class="consent-text">
                                            By submitting this form, you hereby grant us permission
                                            to contact you via
                                            <span>SMS, WhatsApp, RCS, Email</span>, and any other
                                            communication channel.
                                        </span>
                                    </label>
                                </div>
                                <span id="error-message" class="error-message"></span>
                            </div>



                            <!-- Submit -->
                            <div class="col-lg-3">
                                <button type="button" class="submit-btn" id="submitBtn" (click)="submitEnquiryForm()">
                                    Submit
                                </button>
                            </div>

                        </div>
                    </form>


                </div>



                <div class="col-lg-5 mt-2-9">
                    <div class="contact-details">
                        <div class="row">
                            <div class="section-title-04 mb-6 position-relative">
                                <h2 class="title-main2 display-16 lh-1 mb-0 text-white">
                                    Contact details </h2>
                                <div class="line black"></div>
                            </div>
                            <div class="col-lg-12">
                                <div class="contact-info">
                                    <div class="contacts-icon">
                                        <img src="/assets/images/icons/icon-06.png" alt="Email" />
                                    </div>
                                    <div class="contacts-title">
                                        <h5 class="text-white font-weight-600 display-28">Send E-Mail </h5>
                                        <h6 class="text-white font-weight-500">info@redmonkwellness.com</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="contact-info">
                                    <div class="contacts-icon upper">
                                        <img src="/assets/images/icons/icon-07.png" alt="Call" />
                                    </div>
                                    <div class="contacts-title">
                                        <h5 class="text-white font-weight-600 display-28">Call Us </h5>
                                        <h6 class="text-white font-weight-500">+91 62-62-662-662
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="contact-info upper2">
                                    <div class="contacts-icon">
                                        <img src="/assets/images/icons/icon-05.png" alt="Address" />
                                    </div>
                                    <div class="contacts-title">
                                        <h5 class="text-white font-weight-600 display-28"> Locations - Mumbai </h5>
                                        <h6 class="text-white font-weight-500">
                                            Unit No. B-36, Ground Floor A Wing, Laxmi Business Park, Laxmi Industrial
                                            Estate, Sab TV Lane, Off Link Road, Andheri West, Mumbai 400053.
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="follow-company-icon2">
                                <a href="https://www.facebook.com/redmonkwellness" target="_blank"> <i
                                        class="fab fa-facebook-f"></i> </a>

                                <a href="https://www.instagram.com/redmonkwellness/" target="_blank"> <i
                                        class="fab fa-instagram"></i> </a>

                                <a href="https://www.linkedin.com/company/red-monk-wellness" target="_blank"> <i
                                        class="fab fa-linkedin"></i> </a>

                            </div> -->
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</section>